// $( document ).ready(function() {
//    $("header nav .list-menu li").hover(
//       function () {
//         $('nav details:nth-child(1)').removeAttr('open');
//         $('nav summary:nth-child(1)').attr('aria-expanded','false');
//         $(this).find('details:nth-child(1)').attr('open','');
//         $(this).find('summary:nth-child(1)').attr('aria-expanded','true');
//       },
//       function () {
//          $('nav details:nth-child(1)').removeAttr('open');
//          $('nav summary:nth-child(1)').attr('aria-expanded','false');
//       }
//     );
// });

$( document ).ready(function() {
   $("header nav .list-menu li").hover(
      function () {
        $(this).find('details:first').attr('open', 'true');
        $(this).find('summary:first').attr('aria-expanded', 'true');
      },
      function () {
         $(this).find('details:first').removeAttr('open');
         $(this).find('summary:first').attr('aria-expanded', 'false');
      }
    );
});




// Get the body element
var body = document.body;

// Traverse through the child nodes of the body
for (var i = 0; i < body.childNodes.length; i++) {
    var node = body.childNodes[i];
    // Check if the node is a text node and not inside a <div>
    if (node.nodeType === 3 && !node.parentNode.matches("div")) {
        // Replace the word "Test" with an empty string
        node.nodeValue = node.nodeValue.replace(/\bTest\b/g, "");
    }
}
